import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const XboxNetworkSubForm = loadable(() =>
  withDefaultLoaderModifiers(import("./XboxNetworkSubForm"))
);
